// extracted by mini-css-extract-plugin
export default {"tooltip":"to-z","sharingV2":"uo-z","sharingIconsV2":"vo-z","links":"wo-z","link":"xo-z","facebookV2":"yo-z","twitterV2":"zo-z","pinterestV2":"Ao-z"};